'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('workorder-ticket-edit', {
      url: '/workorder/ticket/edit/:id',
      params: {propertyId: null, communityId: null},
      template: '<work-order-ticket-edit></work-order-ticket-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/workorders/ticket-edit/workorder-ticket-edit.routes.js